// Length of the free trial every new MediLink Pro subscription starts with.
// Display only — the server decides the real trial (STRIPE_TRIAL_DAYS, default
// in server/src/routes/signupCheckout.js and stripe.js). Keep the two in sync.
export const TRIAL_DAYS = 14;
